module.exports = __webpack_public_path__ + "static/media/icon_wechat.b4ffe3b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/icon_wechat.svg
// module id = 42
// module chunks = 0